/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeIReadOnlyListSellbotGrantDto,
  ApiEnvelopeIReadOnlyListSellbotGrantRedemptionDto,
  ApiEnvelopeSellbotEmptyDto,
  ApiEnvelopeSellbotGrantDto,
  SellbotGrantRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type sellbotGrantListResponse200 = {
  data: ApiEnvelopeIReadOnlyListSellbotGrantDto
  status: 200
}

export type sellbotGrantListResponseSuccess = (sellbotGrantListResponse200) & {
  headers: Headers;
};
;

export type sellbotGrantListResponse = (sellbotGrantListResponseSuccess)

export const getSellbotGrantListUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/grants`
}

export const useSellbotGrantListHook = (): (botId: string, options?: RequestInit) => Promise<sellbotGrantListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotGrantListUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotGrantCreateResponse200 = {
  data: ApiEnvelopeSellbotGrantDto
  status: 200
}

export type sellbotGrantCreateResponseSuccess = (sellbotGrantCreateResponse200) & {
  headers: Headers;
};
;

export type sellbotGrantCreateResponse = (sellbotGrantCreateResponseSuccess)

export const getSellbotGrantCreateUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/grants`
}

export const useSellbotGrantCreateHook = (): (botId: string,
    sellbotGrantRequest?: SellbotGrantRequest, options?: RequestInit) => Promise<sellbotGrantCreateResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotGrantRequest?: SellbotGrantRequest, options?: RequestInit) => {

        return customFetcher(getSellbotGrantCreateUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotGrantRequest)
  }
);
      }
  }


export type sellbotGrantRedemptionsResponse200 = {
  data: ApiEnvelopeIReadOnlyListSellbotGrantRedemptionDto
  status: 200
}

export type sellbotGrantRedemptionsResponseSuccess = (sellbotGrantRedemptionsResponse200) & {
  headers: Headers;
};
;

export type sellbotGrantRedemptionsResponse = (sellbotGrantRedemptionsResponseSuccess)

export const getSellbotGrantRedemptionsUrl = (botId: string,
    grantId: string,) => {




  return `/api/sellbot/${botId}/grants/${grantId}/redemptions`
}

export const useSellbotGrantRedemptionsHook = (): (botId: string,
    grantId: string, options?: RequestInit) => Promise<sellbotGrantRedemptionsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    grantId: string, options?: RequestInit) => {

        return customFetcher(getSellbotGrantRedemptionsUrl(botId,grantId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotGrantUpdateResponse200 = {
  data: ApiEnvelopeSellbotGrantDto
  status: 200
}

export type sellbotGrantUpdateResponseSuccess = (sellbotGrantUpdateResponse200) & {
  headers: Headers;
};
;

export type sellbotGrantUpdateResponse = (sellbotGrantUpdateResponseSuccess)

export const getSellbotGrantUpdateUrl = (botId: string,
    grantId: string,) => {




  return `/api/sellbot/${botId}/grants/${grantId}`
}

export const useSellbotGrantUpdateHook = (): (botId: string,
    grantId: string,
    sellbotGrantRequest?: SellbotGrantRequest, options?: RequestInit) => Promise<sellbotGrantUpdateResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    grantId: string,
    sellbotGrantRequest?: SellbotGrantRequest, options?: RequestInit) => {

        return customFetcher(getSellbotGrantUpdateUrl(botId,grantId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotGrantRequest)
  }
);
      }
  }


export type sellbotGrantDeleteResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotGrantDeleteResponseSuccess = (sellbotGrantDeleteResponse200) & {
  headers: Headers;
};
;

export type sellbotGrantDeleteResponse = (sellbotGrantDeleteResponseSuccess)

export const getSellbotGrantDeleteUrl = (botId: string,
    grantId: string,) => {




  return `/api/sellbot/${botId}/grants/${grantId}`
}

export const useSellbotGrantDeleteHook = (): (botId: string,
    grantId: string, options?: RequestInit) => Promise<sellbotGrantDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    grantId: string, options?: RequestInit) => {

        return customFetcher(getSellbotGrantDeleteUrl(botId,grantId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotGrantRevokeResponse200 = {
  data: ApiEnvelopeSellbotGrantDto
  status: 200
}

export type sellbotGrantRevokeResponseSuccess = (sellbotGrantRevokeResponse200) & {
  headers: Headers;
};
;

export type sellbotGrantRevokeResponse = (sellbotGrantRevokeResponseSuccess)

export const getSellbotGrantRevokeUrl = (botId: string,
    grantId: string,) => {




  return `/api/sellbot/${botId}/grants/${grantId}/revoke`
}

export const useSellbotGrantRevokeHook = (): (botId: string,
    grantId: string, options?: RequestInit) => Promise<sellbotGrantRevokeResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    grantId: string, options?: RequestInit) => {

        return customFetcher(getSellbotGrantRevokeUrl(botId,grantId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


